import React from "react"
import { connect } from "react-redux"

import { selectIsActionButtonActive } from "shared/search/selectors"
import { setActiveActionButton } from "shared/search/action-creators"

import ActionButton from "shared/search/components/FilterableListView/ActionButton"

const mapStateToProps = (state, props) => ({
    isActive: selectIsActionButtonActive(state, props),
})

const actions = {
    setActiveActionButton,
}

export default connect(mapStateToProps, actions)(ActionButton)
